
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.66 4.5l5.68 1.04-.63-1.76A4 4 0 112.78 9.4l-1.82.82A6 6 0 106 1.79L5.4.1 1.66 4.5z","fill":"#000"}})])
          )
        }
      }
    